import { $api } from "../AxiosInstance";

export class TranslationKeyService {

    /**
     * @param {Object} params
     * @param {Number} params.page
     * @param {Number} params.size
     */

    static  getAllTranslationsKeys(params) {
        return  $api.post(
            "/api/front/language-package-keys",
            params,
        );
    }

    /**
     * @param {Object} params
     * @param {Number} params.page
     * @param {Number} params.size
     */

    static  getPaginationTranslationsKeys(params) {
        return  $api.post(
            "/api/front/language-package-key-pagination",
            params,
        );
    }

    /**
     * @param {Array<{key: String, defaultValue: String, defaultValueLanguageId: String, runTranslationProcess: Boolean}>} translations
     */

    static  addTranslationKeys(translations) {
       return $api.post(
            "/api/front/language-package-key-multiple",
            translations,
        );
    }

    static getTranslationKeyById(id) {
        return $api.get(
            `/api/front/language-package-key/${id}`,
        );
    }

    /**
     * @param {String} id
     * @param {Object} translation
     * @param {String} translation.key
     * @param {String} translation.defaultValue
     * @param {String} translation.defaultValueLanguageId
     *
     */

    static  updateTranslationKeyById( translation) {
        return $api.patch(
            `/api/front/language-package-key/${translation?.id}`,
            translation,
        );
    }

    static deleteTranslationKeyById(id) {
        return $api.delete(`/api/front/language-package-key/${id}`);
    }

    static deleteAllTranslationKeys() {
        return $api.delete(`/api/front/language-package-keys`);
    }


}